import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import queryString from 'query-string';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  public mac = '';
  public status = 0;
  public phone = '';
  public selected = "8";
  constructor(private route: ActivatedRoute, private router: Router, private _snackBar: MatSnackBar) { };
  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (typeof params['mac'] !== 'undefined' && params['mac'].length >= 12) {
        this.mac = params['mac'];
        this.getStatus();
        // console.log(this.mac);
      }
    });
  }
  getStatus() {
    let mac = queryString.stringify({ mac: this.mac });
    axios.post('https://api.sasakonnect.net/purifierStatus', mac).then(result => {
      // console.log(result.data);
      this.status = result.data.status;
      setTimeout(() => {
        if (this.status === 1) {
          // wait for pay request
        } else {
          this.router.navigate(['offline']);
        }
      }, 1000);
    }).catch(error => {
      console.log(error);
    })
  }
  payRequest() {
    if (this.mac.length === 12 && this.phone.length > 0) {
      let msg = 'You will pay Ksh '+ this.selected +' for clear water!'
      Swal.fire({
        text: msg,
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "OK"
      }).then(result => {
        if (result.isConfirmed) {
          let data = queryString.stringify({
            mac: this.mac,
            phone: '+254' + this.phone,
            amount: this.selected
          });
          axios.post('https://api.sasakonnect.net/iClearPayRequest', data).then(result => {
            // check pay result
            if (typeof result.data.error !== 'undefined' && result.data.error.length > 0) {
              this._snackBar.open(result.data.error, 'OK');
            }
          }).catch(error => {
            console.log(error);
          })
        } else {
          // cancel payment
        }
      });
    } else {
      Swal.fire({
        text: "Please scan QR code and input phone number!",
        icon: "question",
        confirmButtonColor: "#1690f0",
        confirmButtonText: "OK"
      });
    }
  }
}
